<template>
  <div class="row mb-3 p-2 bg-white">
    <div class="col-3 p-0">
      <a class="text-reset text-decoration-none" :href="page.url">
        <wf-load-image
          :wrapperClass="'w-100'"
          :imageClass="'image full-image blog-image'"
          :src="page.imageUrl"
          :alt="page.title"
        />
      </a>
    </div>
    <div class="col-9">
      <div class="ml-3 mt-2">
        <div class="page-title">{{ page.type }}</div>
        <div class="page-subtitle" v-html="$helpers.matchText(page.title, searchTerm)"></div>
        <div class="page-date">{{ page.date }}</div>
        <a class="text-reset text-decoration-none" :href="page.url">
          <div class="page-description">{{ page.content }}</div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import WFLoadImage from "../wf-load-image.vue";
import { Icon } from "@iconify/vue2";

export default {
  components: {
    "wf-load-image": WFLoadImage,
    Icon,
  },
  props: ["page"],
  computed: {
    ...mapGetters({
      searchTerm: "searchMenu/searchTerm",
    }),
  },
};
</script>